import React, { useState } from 'react'
import XLSX from 'xlsx'
import ImportIcon from '@mui/icons-material/CloudUpload'
import { ApiService } from '@carrier-ecat/workflowui-globalfunctions'
import { apiUrl } from '../../../environments/environments'
import AppButton from '../../global/AppButton'
import ImportHelp from './importHelp'
import ImportModeDialog from './ImportModeDialog'

const readRows = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onerror = () => reject(new Error('The file could not be read.'))
        reader.onload = (event) => {
            try {
                const workBook = XLSX.read(event.target.result, { type: 'binary' })
                const workSheet = workBook.Sheets[workBook.SheetNames[0]]
                const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1, blankrows: false })
                // The first row is the header
                fileData.splice(0, 1)
                resolve(fileData)
            } catch (error) {
                reject(error)
            }
        }
        reader.readAsBinaryString(file)
    })

const errorMessage = (error) => error.response?.data?.error?.message ?? error.response?.data?.message ?? error.message

function ImportButton({ api, tableLabel = 'Rooftop prices', onSuccess, onError, onStart }) {
    const [dialogOpen, setDialogOpen] = useState(false)
    const [helpOpen, setHelpOpen] = useState(false)

    const importFile = async (file, mode) => {
        setDialogOpen(false)
        try {
            const fileData = await readRows(file)
            onStart()
            const { status, data } = await ApiService(`${apiUrl}${api}?mode=${mode}`, 'post', fileData)
            if (status === 200 && data) onSuccess(data, mode)
        } catch (error) {
            onError(errorMessage(error))
        }
    }

    return (
        <>
            <AppButton color='info' size='medium' startIcon={<ImportIcon />} onClick={() => setDialogOpen(true)}>
                Upload new prices
            </AppButton>
            <ImportModeDialog
                open={dialogOpen}
                tableLabel={tableLabel}
                onClose={() => setDialogOpen(false)}
                onConfirm={importFile}
                onShowHelp={() => setHelpOpen(true)}
            />
            <ImportHelp api={api} open={helpOpen} onClose={() => setHelpOpen(false)} />
        </>
    )
}
export default ImportButton
